import { render, staticRenderFns } from "./TransactionListQA.vue?vue&type=template&id=20883092&scoped=true"
import script from "./TransactionListQA.vue?vue&type=script&lang=js"
export * from "./TransactionListQA.vue?vue&type=script&lang=js"
import style0 from "./TransactionListQA.vue?vue&type=style&index=0&id=20883092&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20883092",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/websites/streamlined-business-solutions/sbs-client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('20883092')) {
      api.createRecord('20883092', component.options)
    } else {
      api.reload('20883092', component.options)
    }
    module.hot.accept("./TransactionListQA.vue?vue&type=template&id=20883092&scoped=true", function () {
      api.rerender('20883092', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/feedback/TransactionListQA.vue"
export default component.exports